/**
 * frontend/lib/authFetch.js
 * fetch() that attaches the Supabase access token.
 *
 * Prompt 1.5 (P0 security fix): every backend route that writes rewards or
 * changes an account now requires `Authorization: Bearer <access_token>` and
 * takes the user from that token — never from a user_id in the body. Use this
 * for those calls; plain fetch() is still fine for public reads.
 */

import { supabase } from './supabaseClient';

export async function authHeaders(extra = {}) {
  const { data, error } = await supabase.auth.getSession();
  if (error) {
    console.warn('[authFetch] getSession failed:', error.message);
    return { ...extra };
  }
  const token = data?.session?.access_token;
  return token ? { ...extra, Authorization: `Bearer ${token}` } : { ...extra };
}

export async function authFetch(url, options = {}) {
  const headers = await authHeaders(options.headers || {});
  return fetch(url, { ...options, headers });
}
